import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
  mutation AddSingleFotoToCartMutation($input: AddSingleFotoToCartInput!) {
    addSingleFotoToCart(input: $input) {
      cart {
        id
        lineItems {
          id
          product {
            label
            price
          }
        }
        totalPrice
      }
    }
  }
`;

function commit(environment, productId, fotoMediaId, callback) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {
        productId,
        fotoMediaId,
      },
    },
    updater: store => {
      const payload = store.getRootField('addSingleFotoToCart');
      const cart = payload.getLinkedRecord('cart');
      const viewer = store.get('root');
      viewer.setLinkedRecord(cart, 'cart');
    },
    onCompleted: (response, errors) => {
      if (errors) {
        callback && callback(errors[0]);
      } else {
        callback && callback(null, response.addSingleFotoToCart.cart);
      }
    },
    onError: err => {
      callback && callback(err);
    },
  });
}

export default { commit };
